import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-sm rounded overflow-hidden shadow-lg m-10 cursor-pointer" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "px-6 py-4" }
const _hoisted_4 = { class: "font-bold text-xl mb-2" }
const _hoisted_5 = { class: "text-gray-700 text-base" }



  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCard',
  props: {
    title: {},
    description: {},
    image: {}
  },
  setup(__props: any) {

  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "w-full",
      src: '/img/' + props.image,
      alt: props.title
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.title), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(props.description), 1)
    ])
  ]))
}
}

})